import { HttpErrorResponse } from '@angular/common/http';
import { Component, inject, input, output, signal } from '@angular/core';

import { Subject } from 'rxjs';

import { CamAddEventRequest } from '@camelot/calendar';
import { FormComponent } from '@camelot/form-basic';
import { CamAbstractInput, IInputsError } from '@camelot/form-model';
import { ENotificationCode, LAZY_SERVICE_TOKEN } from '@camelot/notification';
import { CamBaseComponent } from '@camelot/utils';

import { VisitCreationPayloadInput } from '../../../services/dto/post/visit-creation-payload-input';
import { CamVisitEventsService } from '../../../services/visits.service';

export interface PlanningVisitFormService {
  getEventForm: (data?: CamAddEventRequest) => CamAbstractInput[];
  formatEventForm: (data: any) => VisitCreationPayloadInput[];
}

@Component({
  selector: 'cam-visit-event-form',
  imports: [FormComponent],
  templateUrl: './event.component.html',
  styleUrl: './event.component.scss',
})
export class EventFormComponent extends CamBaseComponent {
  data = input<CamAddEventRequest>();

  formService = input.required<PlanningVisitFormService>();

  askValidation = input.required<Subject<null>>();

  loader = input(false);
  error = input<IInputsError>({ message: '', status: ENotificationCode.none });

  isFormValid = output<boolean>();

  added = output<void>();

  private _visitEventService = inject(CamVisitEventsService);
  protected _notificationService = inject(LAZY_SERVICE_TOKEN);

  public readonly form = signal<CamAbstractInput[]>([]);

  ngOnInit() {
    this.form.set(this.formService().getEventForm(this.data()));
  }

  public validation(data: any) {
    this.requestState.asked();

    const visits = this.formService().formatEventForm(data);

    this._registerSubscription(
      this._visitEventService.createVisit$(visits).subscribe({
        complete: () => {
          this.requestState.completed();
          this._notificationService.addNotification('notification.common.success', ENotificationCode.success);
          this.added.emit();
        },
        error: (error: HttpErrorResponse) => {
          this.requestState.onError(error.status, error.statusText);
        },
      })
    );
  }
}
